<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select [(ngModel)]="reasonId" (valueChange)="setValue($event)" [disabled]="reasons.length === 0" [required]="required">
    @for (reason of reasonsInCategory(); track reason) {
      <mat-option [value]="reason.id">
        {{ reason.name }}
      </mat-option>
    }
    @for (category of categories; track category) {
      <mat-optgroup [label]="category.name">
        @for (reason of reasonsInCategory(category); track reason) {
          <mat-option [value]="reason.id">
            {{ reason.name }}
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>
</mat-form-field>

